import { render, staticRenderFns } from "./ownerExpensesRegisterAction.vue?vue&type=template&id=21f01904&scoped=true"
import script from "./ownerExpensesRegisterAction.vue?vue&type=script&lang=js"
export * from "./ownerExpensesRegisterAction.vue?vue&type=script&lang=js"
import style0 from "./ownerExpensesRegisterAction.vue?vue&type=style&index=0&id=21f01904&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21f01904",
  null
  
)

export default component.exports